import { createContext } from "react";

export const RamosContext = createContext()
export const RamosFormContext = createContext()
export const RamosReportContext = createContext()